import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { env } from '../../config/env';

const bugsnagClient = Bugsnag.start({
  apiKey: env.BUGSNAG_KEY,
  plugins: [new BugsnagPluginReact(React)],
  releaseStage: process.env.NODE_ENV,
  enabledReleaseStages: ['production'],
});

export function setBugsnagUser(uid, displayName, email) {
  if (bugsnagClient) {
    bugsnagClient.setUser(uid, displayName, email);
  }
}

export default bugsnagClient;